const API = 'http://localhost:5001/api';

//
// 🧠 Tipos
//

export interface Ejercicio {
  id: string;
  nombre: string;
  estilo: string;
  nivel: string;
  grupoMuscular: string;
  imagenURL: string;
  activo: boolean;
  series?: number;
  repeticiones?: number;
  descanso?: number;
  dia?: string;
}

export interface Rutina {
  nombre: string;
  nivel: string;
  duracion: number;
  ejercicios: Ejercicio[];
  usuarioId: string;
  adminId: string;
}

export interface PaqueteInput {
  nombre: string;
  limiteRutinas: number;
  precio: number;
  entrenadorId: string | null;
}

export interface PaqueteCheck {
  rutinas: number;
  limite: number;
  ok: boolean;
}

//
// 📦 Funciones API
//

// 🔽 Obtener todos los ejercicios base
export async function obtenerEjercicios(): Promise<Ejercicio[]> {
  const res = await fetch(`${API}/ejercicios`);
  if (!res.ok) throw new Error('❌ Error al cargar ejercicios');
  return await res.json();
}

// 🧱 Crear rutina personalizada
export async function crearRutina(rutina: Rutina): Promise<any> {
  const res = await fetch(`${API}/plantillas`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(rutina),
  });
  if (!res.ok) throw new Error('❌ Error al crear rutina');
  return await res.json();
}

// 📄 Descargar rutina predeterminada como PDF
export function descargarPdfPredeterminada(id: string): void {
  window.open(`${API}/pdf/rutinas/predeterminadas/${id}`, '_blank');
}

// 📦 Verificar si el entrenador puede crear más rutinas
export async function verificarPaquete(adminId: string): Promise<PaqueteCheck> {
  const res = await fetch(`${API}/paquetes/verificar/${adminId}`);
  if (!res.ok) throw new Error('❌ Error al verificar paquete');
  return await res.json();
}

// 🎁 Registrar nuevo paquete
export async function registrarPaquete(paquete: PaqueteInput): Promise<any> {
  const res = await fetch(`${API}/paquetes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paquete),
  });
  if (!res.ok) throw new Error('❌ Error al registrar paquete');
  return await res.json();
}

// 📚 Obtener plantillas para usuarios
export async function obtenerPlantillas(): Promise<Rutina[]> {
  const res = await fetch(`${API}/plantillas`);
  if (!res.ok) throw new Error('❌ Error al obtener plantillas');
  return await res.json();
}
